import React, { useContext, useState } from "react";
import { GlobalContext } from "../context/GlobalContext";

function Info(props) {
    
    const {lang} = useContext(GlobalContext)
    
    const [paraph, setParaph] = useState(props.longDesc.split("/n"))

    return(
        <div className="info projDet" id="info-det">
            {paraph.map((p) => {
                return(
                    <p className="info__longDesc">{p}</p>
                )
            })}
            

            {props.coworkers.length === 0 
            
            ? 
            
            null 
            
            : 
                <div className="info__coworkers">
                    <h4 className="info__cowTitle">{lang === "ingles" ? "Coworkers " : "Compañeros "}</h4>
                    <div className="info__cowLinks">
                        {props.coworkers.map((cow) => {
                            return(
                                <div className="info__coworker">
                                    <img className="info__icon" src="https://firebasestorage.googleapis.com/v0/b/portfolioljk.appspot.com/o/Contacts%2Flinkedin.png?alt=media&token=7bad6bf9-d18f-4a35-a475-a028c0663910" alt="LinkedIn Icon"/>
                                    <h4 className="info__name"><a href={cow.link}>{cow.name}</a></h4>
                                </div>
                            )
                        })}
                    </div>    
                </div>
            }
        </div>
    )
}

export default Info